export const SUPPORT_TICKETS_QUERY = `
  query SupportTickets {
    supportTickets {
      id
      ticketNumber
      subject
      category
      priority
      status
      submittedByName
      submittedByEmail
      submittedByRole
      attachmentFileNames
      createdAt
      updatedAt
    }
  }
`;

export const SUPPORT_MY_TICKETS_QUERY = `
  query SupportMyTickets {
    supportMyTickets {
      id
      ticketNumber
      subject
      category
      priority
      status
      submittedByName
      submittedByEmail
      submittedByRole
      attachmentFileNames
      createdAt
      updatedAt
    }
  }
`;

export const SUPPORT_TICKET_QUERY = `
  query SupportTicket($id: String!) {
    supportTicket(id: $id) {
      id
      ticketNumber
      subject
      category
      priority
      status
      description
      attachmentFileNames
      submittedByUserId
      submittedByName
      submittedByEmail
      submittedByRole
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_SUPPORT_TICKET_MUTATION = `
  mutation UpdateSupportTicket($input: UpdateSupportTicketInput!) {
    updateSupportTicket(input: $input) {
      id
      ticketNumber
      subject
      category
      priority
      status
      description
      attachmentFileNames
      submittedByName
      submittedByEmail
      submittedByRole
      createdAt
      updatedAt
    }
  }
`;

export const SUPPORT_TICKET_MESSAGES_QUERY = `
  query SupportTicketMessages($ticketId: String!) {
    supportTicketMessages(ticketId: $ticketId) {
      id
      content
      senderUserId
      senderName
      senderRole
      attachmentFileNames
      createdAt
    }
  }
`;

export const CREATE_SUPPORT_TICKET_MUTATION = `
  mutation CreateSupportTicket($input: CreateSupportTicketInput!) {
    createSupportTicket(input: $input) {
      id
      ticketNumber
      subject
      category
      priority
      status
      description
      attachmentFileNames
      submittedByUserId
      submittedByName
      submittedByEmail
      submittedByRole
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_SUPPORT_TICKET_MESSAGE_MUTATION = `
  mutation CreateSupportTicketMessage($input: CreateSupportTicketMessageInput!) {
    createSupportTicketMessage(input: $input) {
      id
      content
      senderUserId
      senderName
      senderRole
      attachmentFileNames
      createdAt
    }
  }
`;

